import * as React from 'react';

export const TopBar = ({
	children,
	onClick,
}: {
	children: React.ReactElement | string;
	onClick: () => void;
}) => {
	return (
		<div className="fi-top-bar">
			<button
				className="fi-top-bar__back-button"
				onClick={onClick}
				aria-label="Back to Search"
			>
				<div className="fi-top-bar__back-icon"></div>
				<div className="fi-top-bar__back-text">{children}</div>
			</button>
		</div>
	);
};
